// Angular Core
import { Injectable } from '@angular/core';

// Interfaces
import { MaskFormats } from '../../interfaces/MaskFormats';

@Injectable({
  providedIn: 'root',
})
export class InputMaskService {
  maskFormats: MaskFormats[] = [
    {
      description: 'cpf',
      format: '000.000.000-00',
    },
    {
      description: 'phone',
      format: '(00) 0 0000-0000',
    },
    {
      description: 'phone-br',
      format: ['(00) 0000-0000', '(00) 0 0000-0000'],
    },
    {
      description: 'zip code',
      format: '00000-000',
    },
    {
      description: 'cnpj',
      format: '00.000.000/0000-00',
    },
    {
      description: 'cpf and cnpj',
      format: ['000.000.000-00', '00.000.000/0000-00'],
    },
    {
      description: 'time',
      format: '00:00',
    },
    {
      description: 'maxLength(4)',
      format: 'AAAA',
    },
    {
      description: 'number',
      format: '0*',
    },
  ];

  returnCorrectMaskFormat(formatType: string): string {
    let formatFound: MaskFormats | undefined = this.maskFormats.find(
      (maskFormat: MaskFormats) => maskFormat.description === formatType
    );

    if (!formatFound) {
      return '';
    }

    if (Array.isArray(formatFound.format)) {
      return formatFound.format.join('||');
    }

    return formatFound.format;
  }
}
